import './assets/TermsAndCondition.css';const a = "#ffffff", o = "#396e75", t = "#e5fdff", r = "#546223", n = "#f0fae5", d = "#a65523", l = "#fff1e8", e = "#7f3e3e", c = "#ffe2e2", i = "#62625a", s = "#f8f8e7", z = "#38539a", V = "#707070", g = "#c8f8d1", C = "#87c9c8", f = "#5291b1", k = "rgba(82, 145, 177, 0.1019607843)", h = "#445685", u = "#181d61", B = "rgba(24, 29, 97, 0.1019607843)", _ = "#5969d6", G = "#ea999d", O = "#b6577e", b = "rgba(182, 87, 126, 0.1019607843)", w = "#7e3e80", R = "#1e247f", W = "rgba(30, 36, 127, 0.1019607843)", m = "#da7600", y = "#107f47", Y = "#d91734", p = "_html_1uhlf_34", x = {
  amwayWhite: a,
  darkBlue: o,
  lightBlue: t,
  darkGreen: r,
  lightGreen: n,
  darkOrange: d,
  lightOrange: l,
  darkRed: e,
  lightRed: c,
  darkYellow: i,
  lightYellow: s,
  darkPurple: z,
  darkGrayOnWhite: V,
  dataVizColor1: g,
  dataVizColor2: C,
  dataVizColor3: f,
  dataVizColor3Background: k,
  dataVizColor4: h,
  dataVizColor5: u,
  dataVizColor5Background: B,
  dataVizColor6: _,
  dataVizColor7: G,
  dataVizColor8: O,
  dataVizColor8Background: b,
  dataVizColor9: w,
  dataVizColor10: R,
  dataVizColor10Background: W,
  dataVizAlertOrange: m,
  dataVizSuccessGreen: y,
  dataVizWarningRed: Y,
  html: p,
  "tnc-container": "_tnc-container_1uhlf_68",
  "tnc-text": "_tnc-text_1uhlf_72",
  "tnc-link": "_tnc-link_1uhlf_82"
};
export {
  x as s
};
//# sourceMappingURL=TermsAndCondition.module-c1ab9d2b.mjs.map
